import css from './H2title.module.scss';
import classNames from 'classnames';

export default function H2title({children, cn, isWhite}) {
  return (
    <h2 className={classNames(css.h2, cn, {[css.white]: isWhite})}>{children}</h2>
  );
}